<template>
  <div class="row services">
    <div class="col-lg-4 col-md-6 col-12">
      <div class="itemcard downloadcard">
        <router-link to="/residential">
          <img src="@/assets/img/svg/residential-proxy.svg" />
          <h2 class="helperbird-editor medium-editor-element">Residential proxies</h2>
        </router-link>
        <p class="helperbird-editor medium-editor-element">
          Residential proxies are a fantastic alternative to datacenter proxies. Residential proxies
          are less likely to be blocked on superior targets.
        </p>
        <div class="downloadbtn">
          <router-link to="/residential">Learn more</router-link>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-12">
      <div class="itemcard downloadcard">
        <router-link to="/premium?ref=home">
          <img alt="premium proxies" src="@/assets/img/svg/premium-proxies.svg" />
          <h2 class="helperbird-editor medium-editor-element">Premium proxies</h2>
        </router-link>
        <p class="helperbird-editor medium-editor-element">
          Are you tired of free proxies that always die? Do you want proxies that work and are
          online whenever you need them? Than you should try out ProxyScrape premium!
        </p>
        <div class="downloadbtn"><a href="/premium?ref=home">Tell Me More</a></div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-12">
      <div class="itemcard downloadcard">
        <router-link to="/dedicated?ref=home">
          <img src="@/assets/img/svg/dedicated-proxy.svg" />
          <h2 class="helperbird-editor medium-editor-element">Dedicated proxies</h2>
        </router-link>
        <p class="helperbird-editor medium-editor-element">
          Do you want proxies that are only used by you and have connection speeds of up to 1Gbps?
          Then dedicated proxies are the right choice!
        </p>
        <div class="downloadbtn">
          <router-link to="/dedicated?ref=home"> Get dedicated proxies </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped src="../../assets/css/home.css"></style>
